import {ENTRY_FIELD_DEFINITIONS, EntryRuleName} from "@library/domain/recruit/EntryField";
import {EntryViolation} from "@library/usecase/recruit/ValidateEntryUseCase";

/**
 * 検証ルールごとのメッセージ（app/Language/ja/Validation.php と同じ文言にする）
 */
const MESSAGES: Readonly<Record<EntryRuleName, string>> = {
    required: "{field}は必須です。",
    max_length: "{field}は{param}文字以内で入力してください。",
    valid_email: "{field}には正しいメールアドレスを入力してください。",
    valid_birthday: "{field}には正しい日付（1900-01-01 から今日まで）を入力してください。",
    valid_tel: "{field}には正しい電話番号（数字とハイフン、10〜15 桁）を入力してください。",
    no_control_chars: "{field}に使えない文字が含まれています。",
    single_line: "{field}には改行を含めないでください。",
};

/**
 * 検証の違反を、画面に出すメッセージに変える。
 */
export class EntryErrorMessagePresenter {
    public present(violations: readonly EntryViolation[]): string[] {
        return violations.map((violation) =>
            MESSAGES[violation.rule.name]
                .replace("{field}", ENTRY_FIELD_DEFINITIONS[violation.field].label)
                .replace("{param}", String(violation.rule.param ?? ""))
        );
    }
}
